import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CommonModule, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeCl from '@angular/common/locales/es-CL';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { ErrorComponent } from './components/error/error.component';
import { ExitBannerComponent } from './components/exit-banner/exit-banner.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LoaderComponent } from './components/loader/loader.component';

import { SITE_RECAPTCHA_KEY } from '../environments/environment';
import { GenericModalComponent } from './components/modals/generic-modal/generic-modal.component';
import { UpdatePhoneModalComponent } from './components/modals/update-phone-modal/update-phone-modal.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { SurveyComponent } from './components/survey/survey.component';
import { ErrorInterceptor } from './core/interceptors/error/error.interceptor';
import { HttpAuthenticatorInterceptor } from './core/interceptors/http-authenticator/http-authenticator.interceptor';
import { LoaderInterceptor } from './core/interceptors/loader/loader.interceptor';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { RutFormatterDirective } from './directives/rut-formatter.directive';
import { TwoDigitNumericDirective } from './directives/two-digit-numeric.directive';
import { ValidatePhoneDirective } from './directives/validate-phone.directive';
import { BciWkModule } from './modules/bci-web-kit/bci-wk.module';
import { CompanyDataComponent } from './pages/company-data/company-data.component';
import { MainComponent } from './pages/main/main.component';
import { VerifyPhoneComponent } from './pages/verify-phone/verify-phone.component';
import { TaxFolderComponent } from './pages/tax-folder/tax-folder.component';
import { WhatsAppContactComponent } from './components/whatsapp-contact/whatsapp-contact.component';

registerLocaleData(localeCl);

@NgModule({
	declarations: [
		AppComponent,
		MainComponent,
		ErrorComponent,
		HeaderComponent,
		LoaderComponent,
		CompanyDataComponent,
		FooterComponent,
		VerifyPhoneComponent,
		RutFormatterDirective,
		AutoFocusDirective,
		SurveyComponent,
		ExitBannerComponent,
		SnackbarComponent,
		TwoDigitNumericDirective,
		ValidatePhoneDirective,
		GenericModalComponent,
		UpdatePhoneModalComponent,
		TaxFolderComponent,
		WhatsAppContactComponent,
	],
	imports: [
		CommonModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		BciWkModule,
		RecaptchaV3Module,
	],
	providers: [
		{ provide: LOCALE_ID, useValue: 'es-CL' },
		{ provide: RECAPTCHA_V3_SITE_KEY, useValue: SITE_RECAPTCHA_KEY },
		{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpAuthenticatorInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true,
		},
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	bootstrap: [AppComponent],
})
export class AppModule {}
